import(/* webpackMode: "eager", webpackExports: ["LandingFaqCarousel"] */ "/app/components/landing/faq/landing-faq-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingPrefetch"] */ "/app/components/landing/landing-prefetch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingMessage"] */ "/app/components/landing/message/landing-message.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandMovieTextItem"] */ "/app/components/landing/movie/land-movie-text-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingStats"] */ "/app/components/landing/stats/landing-stats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalInfo"] */ "/app/components/modals/Info-modal.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
